import React from 'react';

// กราฟ SVG เล็ก ๆ วาดเอง (แทน chart.js) — สีมาจาก CSS variables จึงเปลี่ยนตามโหมดสว่าง/มืดเองทันที

function niceMax(v) {
  if (v <= 4) return 4;
  const pow = 10 ** Math.floor(Math.log10(v));
  for (const m of [1, 2, 2.5, 5, 10]) {
    if (m * pow >= v) return m * pow;
  }
  return 10 * pow;
}

export function Sparkline({ data, color = 'var(--accent)', width = 78, height = 30 }) {
  if (!data || data.length < 2) return null;
  const max = Math.max(...data, 1);
  const step = width / (data.length - 1);
  const pts = data.map((v, i) => [i * step, height - 3 - (v / max) * (height - 8)]);
  const line = pts.map((p) => p.join(',')).join(' ');
  const last = pts[pts.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d={`M${pts.map((p) => p.join(',')).join(' L')} L${width},${height} L0,${height} Z`} fill={color} opacity=".12" />
      <polyline points={line} fill="none" stroke={color} strokeWidth="1.6" />
      <circle cx={Math.min(last[0], width - 3)} cy={last[1]} r="2.6" fill={color} />
    </svg>
  );
}

// แท่งซ้อน — series: [{ key, color, data: [] }], labels: [] ; labelEvery: แสดงป้ายแกน x ทุก n แท่ง
export function StackedBars({
  labels, series, width = 640, height = 200, labelEvery = 1, showTotals = false, barRatio = 0.6, ariaLabel,
}) {
  const L = 30; const R = 6; const T = 16; const B = 22;
  const ih = height - T - B; const iw = width - L - R;
  const totals = labels.map((_, i) => series.reduce((s, ser) => s + (ser.data[i] || 0), 0));
  const max = niceMax(Math.max(...totals, 0));
  const ticks = [0, max / 4, max / 2, (3 * max) / 4, max].filter((v) => Number.isInteger(v));
  const gw = iw / labels.length;
  const bw = Math.max(gw * barRatio, 2);
  const y = (v) => T + ih - (v / max) * ih;

  return (
    <svg className="chart" viewBox={`0 0 ${width} ${height}`} role="img" aria-label={ariaLabel}>
      {ticks.map((v) => (
        <g key={v}>
          <line x1={L} x2={width - R} y1={y(v)} y2={y(v)} stroke="var(--grid-line)" strokeWidth="1" />
          <text x={L - 6} y={y(v) + 3.5} textAnchor="end">{v}</text>
        </g>
      ))}
      {labels.map((lb, i) => {
        const x = L + i * gw + (gw - bw) / 2;
        let acc = 0;
        return (
          <g key={`${lb}-${i}`}>
            {series.map((ser) => {
              const v = ser.data[i] || 0;
              if (!v) return null;
              const h = Math.max((v / max) * ih, 1.5);
              const rect = <rect key={ser.key} x={x} y={y(acc) - h} width={bw} height={h} fill={ser.color} rx="1"><title>{`${lb} · ${ser.label}: ${v}`}</title></rect>;
              acc += v;
              return rect;
            })}
            {showTotals && totals[i] > 0 && (
              <text className="val" x={x + bw / 2} y={y(totals[i]) - 4} textAnchor="middle">{totals[i]}</text>
            )}
            {i % labelEvery === 0 && (
              <text x={L + i * gw + gw / 2} y={height - 6} textAnchor="middle">{lb}</text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
